module.exports = __webpack_public_path__ + "img/MAP.5eac6060.svg";